import React from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface Props {
  /**
   * Additional classes
   */
  className?: string

  /**
   * Value to display
   */
  children: React.ReactNode

  /**
   * Maximum number of rows to display
   */
  maxRows?: number

  /**
   * Dimension
   */
  size?: '2XS' | 'XS' | 'S' | 'M' | 'L' | 'XL'
}

const Title: React.FC<Props> = ({
  className,
  children,
  maxRows,
  size = 'S',
}: Props): JSX.Element => {
  return (
    <div
      className={classNames(
        styles.main,
        styles[`rows-${maxRows}`],
        styles[`size-${size.toLowerCase()}`],
        className
      )}
    >
      {children}
    </div>
  )
}

export default Title
